export enum PaymentErrorCode {
  CODE_1 = '1',
  CODE_2 = '2',
  CODE_3 = '3',
}
